/**
 * ApiGest API
 * ApiGest API documentation
 *
 * OpenAPI spec version: 1.0.0
 * Contact: info@eneasys.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { RoleAssignationDTO } from '../model/roleAssignationDTO';

import { AIG_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class RoleAssignationResourceService {

    protected basePath = 'https://api-gest.eneasys.net';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(AIG_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * countRoleAssignations
     * 
     * @param customRoleIdEquals 
     * @param customRoleIdGreaterThan 
     * @param customRoleIdGreaterThanOrEqual 
     * @param customRoleIdIn 
     * @param customRoleIdLessThan 
     * @param customRoleIdLessThanOrEqual 
     * @param customRoleIdNotEquals 
     * @param customRoleIdSpecified 
     * @param groupIdEquals 
     * @param groupIdGreaterThan 
     * @param groupIdGreaterThanOrEqual 
     * @param groupIdIn 
     * @param groupIdLessThan 
     * @param groupIdLessThanOrEqual 
     * @param groupIdNotEquals 
     * @param groupIdSpecified 
     * @param idEquals 
     * @param idGreaterThan 
     * @param idGreaterThanOrEqual 
     * @param idIn 
     * @param idLessThan 
     * @param idLessThanOrEqual 
     * @param idNotEquals 
     * @param idSpecified 
     * @param roleCodeContains 
     * @param roleCodeDoesNotContain 
     * @param roleCodeEquals 
     * @param roleCodeIn 
     * @param roleCodeNotEquals 
     * @param roleCodeSpecified 
     * @param userIdEquals 
     * @param userIdGreaterThan 
     * @param userIdGreaterThanOrEqual 
     * @param userIdIn 
     * @param userIdLessThan 
     * @param userIdLessThanOrEqual 
     * @param userIdNotEquals 
     * @param userIdSpecified 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public countRoleAssignationsUsingGET(customRoleIdEquals?: number, customRoleIdGreaterThan?: number, customRoleIdGreaterThanOrEqual?: number, customRoleIdIn?: Array<number>, customRoleIdLessThan?: number, customRoleIdLessThanOrEqual?: number, customRoleIdNotEquals?: number, customRoleIdSpecified?: boolean, groupIdEquals?: number, groupIdGreaterThan?: number, groupIdGreaterThanOrEqual?: number, groupIdIn?: Array<number>, groupIdLessThan?: number, groupIdLessThanOrEqual?: number, groupIdNotEquals?: number, groupIdSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, roleCodeContains?: string, roleCodeDoesNotContain?: string, roleCodeEquals?: string, roleCodeIn?: Array<string>, roleCodeNotEquals?: string, roleCodeSpecified?: boolean, userIdEquals?: number, userIdGreaterThan?: number, userIdGreaterThanOrEqual?: number, userIdIn?: Array<number>, userIdLessThan?: number, userIdLessThanOrEqual?: number, userIdNotEquals?: number, userIdSpecified?: boolean, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public countRoleAssignationsUsingGET(customRoleIdEquals?: number, customRoleIdGreaterThan?: number, customRoleIdGreaterThanOrEqual?: number, customRoleIdIn?: Array<number>, customRoleIdLessThan?: number, customRoleIdLessThanOrEqual?: number, customRoleIdNotEquals?: number, customRoleIdSpecified?: boolean, groupIdEquals?: number, groupIdGreaterThan?: number, groupIdGreaterThanOrEqual?: number, groupIdIn?: Array<number>, groupIdLessThan?: number, groupIdLessThanOrEqual?: number, groupIdNotEquals?: number, groupIdSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, roleCodeContains?: string, roleCodeDoesNotContain?: string, roleCodeEquals?: string, roleCodeIn?: Array<string>, roleCodeNotEquals?: string, roleCodeSpecified?: boolean, userIdEquals?: number, userIdGreaterThan?: number, userIdGreaterThanOrEqual?: number, userIdIn?: Array<number>, userIdLessThan?: number, userIdLessThanOrEqual?: number, userIdNotEquals?: number, userIdSpecified?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public countRoleAssignationsUsingGET(customRoleIdEquals?: number, customRoleIdGreaterThan?: number, customRoleIdGreaterThanOrEqual?: number, customRoleIdIn?: Array<number>, customRoleIdLessThan?: number, customRoleIdLessThanOrEqual?: number, customRoleIdNotEquals?: number, customRoleIdSpecified?: boolean, groupIdEquals?: number, groupIdGreaterThan?: number, groupIdGreaterThanOrEqual?: number, groupIdIn?: Array<number>, groupIdLessThan?: number, groupIdLessThanOrEqual?: number, groupIdNotEquals?: number, groupIdSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, roleCodeContains?: string, roleCodeDoesNotContain?: string, roleCodeEquals?: string, roleCodeIn?: Array<string>, roleCodeNotEquals?: string, roleCodeSpecified?: boolean, userIdEquals?: number, userIdGreaterThan?: number, userIdGreaterThanOrEqual?: number, userIdIn?: Array<number>, userIdLessThan?: number, userIdLessThanOrEqual?: number, userIdNotEquals?: number, userIdSpecified?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public countRoleAssignationsUsingGET(customRoleIdEquals?: number, customRoleIdGreaterThan?: number, customRoleIdGreaterThanOrEqual?: number, customRoleIdIn?: Array<number>, customRoleIdLessThan?: number, customRoleIdLessThanOrEqual?: number, customRoleIdNotEquals?: number, customRoleIdSpecified?: boolean, groupIdEquals?: number, groupIdGreaterThan?: number, groupIdGreaterThanOrEqual?: number, groupIdIn?: Array<number>, groupIdLessThan?: number, groupIdLessThanOrEqual?: number, groupIdNotEquals?: number, groupIdSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, roleCodeContains?: string, roleCodeDoesNotContain?: string, roleCodeEquals?: string, roleCodeIn?: Array<string>, roleCodeNotEquals?: string, roleCodeSpecified?: boolean, userIdEquals?: number, userIdGreaterThan?: number, userIdGreaterThanOrEqual?: number, userIdIn?: Array<number>, userIdLessThan?: number, userIdLessThanOrEqual?: number, userIdNotEquals?: number, userIdSpecified?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {







































        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (customRoleIdEquals !== undefined && customRoleIdEquals !== null) {
            queryParameters = queryParameters.set('customRoleId.equals', <any>customRoleIdEquals);
        }
        if (customRoleIdGreaterThan !== undefined && customRoleIdGreaterThan !== null) {
            queryParameters = queryParameters.set('customRoleId.greaterThan', <any>customRoleIdGreaterThan);
        }
        if (customRoleIdGreaterThanOrEqual !== undefined && customRoleIdGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('customRoleId.greaterThanOrEqual', <any>customRoleIdGreaterThanOrEqual);
        }
        if (customRoleIdIn) {
            customRoleIdIn.forEach((element) => {
                queryParameters = queryParameters.append('customRoleId.in', <any>element);
            })
        }
        if (customRoleIdLessThan !== undefined && customRoleIdLessThan !== null) {
            queryParameters = queryParameters.set('customRoleId.lessThan', <any>customRoleIdLessThan);
        }
        if (customRoleIdLessThanOrEqual !== undefined && customRoleIdLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('customRoleId.lessThanOrEqual', <any>customRoleIdLessThanOrEqual);
        }
        if (customRoleIdNotEquals !== undefined && customRoleIdNotEquals !== null) {
            queryParameters = queryParameters.set('customRoleId.notEquals', <any>customRoleIdNotEquals);
        }
        if (customRoleIdSpecified !== undefined && customRoleIdSpecified !== null) {
            queryParameters = queryParameters.set('customRoleId.specified', <any>customRoleIdSpecified);
        }
        if (groupIdEquals !== undefined && groupIdEquals !== null) {
            queryParameters = queryParameters.set('groupId.equals', <any>groupIdEquals);
        }
        if (groupIdGreaterThan !== undefined && groupIdGreaterThan !== null) {
            queryParameters = queryParameters.set('groupId.greaterThan', <any>groupIdGreaterThan);
        }
        if (groupIdGreaterThanOrEqual !== undefined && groupIdGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('groupId.greaterThanOrEqual', <any>groupIdGreaterThanOrEqual);
        }
        if (groupIdIn) {
            groupIdIn.forEach((element) => {
                queryParameters = queryParameters.append('groupId.in', <any>element);
            })
        }
        if (groupIdLessThan !== undefined && groupIdLessThan !== null) {
            queryParameters = queryParameters.set('groupId.lessThan', <any>groupIdLessThan);
        }
        if (groupIdLessThanOrEqual !== undefined && groupIdLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('groupId.lessThanOrEqual', <any>groupIdLessThanOrEqual);
        }
        if (groupIdNotEquals !== undefined && groupIdNotEquals !== null) {
            queryParameters = queryParameters.set('groupId.notEquals', <any>groupIdNotEquals);
        }
        if (groupIdSpecified !== undefined && groupIdSpecified !== null) {
            queryParameters = queryParameters.set('groupId.specified', <any>groupIdSpecified);
        }
        if (idEquals !== undefined && idEquals !== null) {
            queryParameters = queryParameters.set('id.equals', <any>idEquals);
        }
        if (idGreaterThan !== undefined && idGreaterThan !== null) {
            queryParameters = queryParameters.set('id.greaterThan', <any>idGreaterThan);
        }
        if (idGreaterThanOrEqual !== undefined && idGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.greaterThanOrEqual', <any>idGreaterThanOrEqual);
        }
        if (idIn) {
            idIn.forEach((element) => {
                queryParameters = queryParameters.append('id.in', <any>element);
            })
        }
        if (idLessThan !== undefined && idLessThan !== null) {
            queryParameters = queryParameters.set('id.lessThan', <any>idLessThan);
        }
        if (idLessThanOrEqual !== undefined && idLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.lessThanOrEqual', <any>idLessThanOrEqual);
        }
        if (idNotEquals !== undefined && idNotEquals !== null) {
            queryParameters = queryParameters.set('id.notEquals', <any>idNotEquals);
        }
        if (idSpecified !== undefined && idSpecified !== null) {
            queryParameters = queryParameters.set('id.specified', <any>idSpecified);
        }
        if (roleCodeContains !== undefined && roleCodeContains !== null) {
            queryParameters = queryParameters.set('roleCode.contains', <any>roleCodeContains);
        }
        if (roleCodeDoesNotContain !== undefined && roleCodeDoesNotContain !== null) {
            queryParameters = queryParameters.set('roleCode.doesNotContain', <any>roleCodeDoesNotContain);
        }
        if (roleCodeEquals !== undefined && roleCodeEquals !== null) {
            queryParameters = queryParameters.set('roleCode.equals', <any>roleCodeEquals);
        }
        if (roleCodeIn) {
            roleCodeIn.forEach((element) => {
                queryParameters = queryParameters.append('roleCode.in', <any>element);
            })
        }
        if (roleCodeNotEquals !== undefined && roleCodeNotEquals !== null) {
            queryParameters = queryParameters.set('roleCode.notEquals', <any>roleCodeNotEquals);
        }
        if (roleCodeSpecified !== undefined && roleCodeSpecified !== null) {
            queryParameters = queryParameters.set('roleCode.specified', <any>roleCodeSpecified);
        }
        if (userIdEquals !== undefined && userIdEquals !== null) {
            queryParameters = queryParameters.set('userId.equals', <any>userIdEquals);
        }
        if (userIdGreaterThan !== undefined && userIdGreaterThan !== null) {
            queryParameters = queryParameters.set('userId.greaterThan', <any>userIdGreaterThan);
        }
        if (userIdGreaterThanOrEqual !== undefined && userIdGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('userId.greaterThanOrEqual', <any>userIdGreaterThanOrEqual);
        }
        if (userIdIn) {
            userIdIn.forEach((element) => {
                queryParameters = queryParameters.append('userId.in', <any>element);
            })
        }
        if (userIdLessThan !== undefined && userIdLessThan !== null) {
            queryParameters = queryParameters.set('userId.lessThan', <any>userIdLessThan);
        }
        if (userIdLessThanOrEqual !== undefined && userIdLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('userId.lessThanOrEqual', <any>userIdLessThanOrEqual);
        }
        if (userIdNotEquals !== undefined && userIdNotEquals !== null) {
            queryParameters = queryParameters.set('userId.notEquals', <any>userIdNotEquals);
        }
        if (userIdSpecified !== undefined && userIdSpecified !== null) {
            queryParameters = queryParameters.set('userId.specified', <any>userIdSpecified);
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<number>('get',`${this.basePath}/api/role-assignations/count`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * createRoleAssignation
     * 
     * @param body roleAssignationDTO
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createRoleAssignationUsingPOST(body: RoleAssignationDTO, observe?: 'body', reportProgress?: boolean): Observable<RoleAssignationDTO>;
    public createRoleAssignationUsingPOST(body: RoleAssignationDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RoleAssignationDTO>>;
    public createRoleAssignationUsingPOST(body: RoleAssignationDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RoleAssignationDTO>>;
    public createRoleAssignationUsingPOST(body: RoleAssignationDTO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createRoleAssignationUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<RoleAssignationDTO>('post',`${this.basePath}/api/role-assignations`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteRoleAssignation
     * 
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteRoleAssignationUsingDELETE(id: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteRoleAssignationUsingDELETE(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteRoleAssignationUsingDELETE(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteRoleAssignationUsingDELETE(id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteRoleAssignationUsingDELETE.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/api/role-assignations/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getAllRoleAssignations
     * 
     * @param customRoleIdEquals 
     * @param customRoleIdGreaterThan 
     * @param customRoleIdGreaterThanOrEqual 
     * @param customRoleIdIn 
     * @param customRoleIdLessThan 
     * @param customRoleIdLessThanOrEqual 
     * @param customRoleIdNotEquals 
     * @param customRoleIdSpecified 
     * @param groupIdEquals 
     * @param groupIdGreaterThan 
     * @param groupIdGreaterThanOrEqual 
     * @param groupIdIn 
     * @param groupIdLessThan 
     * @param groupIdLessThanOrEqual 
     * @param groupIdNotEquals 
     * @param groupIdSpecified 
     * @param idEquals 
     * @param idGreaterThan 
     * @param idGreaterThanOrEqual 
     * @param idIn 
     * @param idLessThan 
     * @param idLessThanOrEqual 
     * @param idNotEquals 
     * @param idSpecified 
     * @param page Page number of the requested page
     * @param roleCodeContains 
     * @param roleCodeDoesNotContain 
     * @param roleCodeEquals 
     * @param roleCodeIn 
     * @param roleCodeNotEquals 
     * @param roleCodeSpecified 
     * @param size Size of a page
     * @param sort Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param userIdEquals 
     * @param userIdGreaterThan 
     * @param userIdGreaterThanOrEqual 
     * @param userIdIn 
     * @param userIdLessThan 
     * @param userIdLessThanOrEqual 
     * @param userIdNotEquals 
     * @param userIdSpecified 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllRoleAssignationsUsingGET(customRoleIdEquals?: number, customRoleIdGreaterThan?: number, customRoleIdGreaterThanOrEqual?: number, customRoleIdIn?: Array<number>, customRoleIdLessThan?: number, customRoleIdLessThanOrEqual?: number, customRoleIdNotEquals?: number, customRoleIdSpecified?: boolean, groupIdEquals?: number, groupIdGreaterThan?: number, groupIdGreaterThanOrEqual?: number, groupIdIn?: Array<number>, groupIdLessThan?: number, groupIdLessThanOrEqual?: number, groupIdNotEquals?: number, groupIdSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, page?: number, roleCodeContains?: string, roleCodeDoesNotContain?: string, roleCodeEquals?: string, roleCodeIn?: Array<string>, roleCodeNotEquals?: string, roleCodeSpecified?: boolean, size?: number, sort?: Array<string>, userIdEquals?: number, userIdGreaterThan?: number, userIdGreaterThanOrEqual?: number, userIdIn?: Array<number>, userIdLessThan?: number, userIdLessThanOrEqual?: number, userIdNotEquals?: number, userIdSpecified?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<RoleAssignationDTO>>;
    public getAllRoleAssignationsUsingGET(customRoleIdEquals?: number, customRoleIdGreaterThan?: number, customRoleIdGreaterThanOrEqual?: number, customRoleIdIn?: Array<number>, customRoleIdLessThan?: number, customRoleIdLessThanOrEqual?: number, customRoleIdNotEquals?: number, customRoleIdSpecified?: boolean, groupIdEquals?: number, groupIdGreaterThan?: number, groupIdGreaterThanOrEqual?: number, groupIdIn?: Array<number>, groupIdLessThan?: number, groupIdLessThanOrEqual?: number, groupIdNotEquals?: number, groupIdSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, page?: number, roleCodeContains?: string, roleCodeDoesNotContain?: string, roleCodeEquals?: string, roleCodeIn?: Array<string>, roleCodeNotEquals?: string, roleCodeSpecified?: boolean, size?: number, sort?: Array<string>, userIdEquals?: number, userIdGreaterThan?: number, userIdGreaterThanOrEqual?: number, userIdIn?: Array<number>, userIdLessThan?: number, userIdLessThanOrEqual?: number, userIdNotEquals?: number, userIdSpecified?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<RoleAssignationDTO>>>;
    public getAllRoleAssignationsUsingGET(customRoleIdEquals?: number, customRoleIdGreaterThan?: number, customRoleIdGreaterThanOrEqual?: number, customRoleIdIn?: Array<number>, customRoleIdLessThan?: number, customRoleIdLessThanOrEqual?: number, customRoleIdNotEquals?: number, customRoleIdSpecified?: boolean, groupIdEquals?: number, groupIdGreaterThan?: number, groupIdGreaterThanOrEqual?: number, groupIdIn?: Array<number>, groupIdLessThan?: number, groupIdLessThanOrEqual?: number, groupIdNotEquals?: number, groupIdSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, page?: number, roleCodeContains?: string, roleCodeDoesNotContain?: string, roleCodeEquals?: string, roleCodeIn?: Array<string>, roleCodeNotEquals?: string, roleCodeSpecified?: boolean, size?: number, sort?: Array<string>, userIdEquals?: number, userIdGreaterThan?: number, userIdGreaterThanOrEqual?: number, userIdIn?: Array<number>, userIdLessThan?: number, userIdLessThanOrEqual?: number, userIdNotEquals?: number, userIdSpecified?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<RoleAssignationDTO>>>;
    public getAllRoleAssignationsUsingGET(customRoleIdEquals?: number, customRoleIdGreaterThan?: number, customRoleIdGreaterThanOrEqual?: number, customRoleIdIn?: Array<number>, customRoleIdLessThan?: number, customRoleIdLessThanOrEqual?: number, customRoleIdNotEquals?: number, customRoleIdSpecified?: boolean, groupIdEquals?: number, groupIdGreaterThan?: number, groupIdGreaterThanOrEqual?: number, groupIdIn?: Array<number>, groupIdLessThan?: number, groupIdLessThanOrEqual?: number, groupIdNotEquals?: number, groupIdSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, page?: number, roleCodeContains?: string, roleCodeDoesNotContain?: string, roleCodeEquals?: string, roleCodeIn?: Array<string>, roleCodeNotEquals?: string, roleCodeSpecified?: boolean, size?: number, sort?: Array<string>, userIdEquals?: number, userIdGreaterThan?: number, userIdGreaterThanOrEqual?: number, userIdIn?: Array<number>, userIdLessThan?: number, userIdLessThanOrEqual?: number, userIdNotEquals?: number, userIdSpecified?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {










































        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (customRoleIdEquals !== undefined && customRoleIdEquals !== null) {
            queryParameters = queryParameters.set('customRoleId.equals', <any>customRoleIdEquals);
        }
        if (customRoleIdGreaterThan !== undefined && customRoleIdGreaterThan !== null) {
            queryParameters = queryParameters.set('customRoleId.greaterThan', <any>customRoleIdGreaterThan);
        }
        if (customRoleIdGreaterThanOrEqual !== undefined && customRoleIdGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('customRoleId.greaterThanOrEqual', <any>customRoleIdGreaterThanOrEqual);
        }
        if (customRoleIdIn) {
            customRoleIdIn.forEach((element) => {
                queryParameters = queryParameters.append('customRoleId.in', <any>element);
            })
        }
        if (customRoleIdLessThan !== undefined && customRoleIdLessThan !== null) {
            queryParameters = queryParameters.set('customRoleId.lessThan', <any>customRoleIdLessThan);
        }
        if (customRoleIdLessThanOrEqual !== undefined && customRoleIdLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('customRoleId.lessThanOrEqual', <any>customRoleIdLessThanOrEqual);
        }
        if (customRoleIdNotEquals !== undefined && customRoleIdNotEquals !== null) {
            queryParameters = queryParameters.set('customRoleId.notEquals', <any>customRoleIdNotEquals);
        }
        if (customRoleIdSpecified !== undefined && customRoleIdSpecified !== null) {
            queryParameters = queryParameters.set('customRoleId.specified', <any>customRoleIdSpecified);
        }
        if (groupIdEquals !== undefined && groupIdEquals !== null) {
            queryParameters = queryParameters.set('groupId.equals', <any>groupIdEquals);
        }
        if (groupIdGreaterThan !== undefined && groupIdGreaterThan !== null) {
            queryParameters = queryParameters.set('groupId.greaterThan', <any>groupIdGreaterThan);
        }
        if (groupIdGreaterThanOrEqual !== undefined && groupIdGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('groupId.greaterThanOrEqual', <any>groupIdGreaterThanOrEqual);
        }
        if (groupIdIn) {
            groupIdIn.forEach((element) => {
                queryParameters = queryParameters.append('groupId.in', <any>element);
            })
        }
        if (groupIdLessThan !== undefined && groupIdLessThan !== null) {
            queryParameters = queryParameters.set('groupId.lessThan', <any>groupIdLessThan);
        }
        if (groupIdLessThanOrEqual !== undefined && groupIdLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('groupId.lessThanOrEqual', <any>groupIdLessThanOrEqual);
        }
        if (groupIdNotEquals !== undefined && groupIdNotEquals !== null) {
            queryParameters = queryParameters.set('groupId.notEquals', <any>groupIdNotEquals);
        }
        if (groupIdSpecified !== undefined && groupIdSpecified !== null) {
            queryParameters = queryParameters.set('groupId.specified', <any>groupIdSpecified);
        }
        if (idEquals !== undefined && idEquals !== null) {
            queryParameters = queryParameters.set('id.equals', <any>idEquals);
        }
        if (idGreaterThan !== undefined && idGreaterThan !== null) {
            queryParameters = queryParameters.set('id.greaterThan', <any>idGreaterThan);
        }
        if (idGreaterThanOrEqual !== undefined && idGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.greaterThanOrEqual', <any>idGreaterThanOrEqual);
        }
        if (idIn) {
            idIn.forEach((element) => {
                queryParameters = queryParameters.append('id.in', <any>element);
            })
        }
        if (idLessThan !== undefined && idLessThan !== null) {
            queryParameters = queryParameters.set('id.lessThan', <any>idLessThan);
        }
        if (idLessThanOrEqual !== undefined && idLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.lessThanOrEqual', <any>idLessThanOrEqual);
        }
        if (idNotEquals !== undefined && idNotEquals !== null) {
            queryParameters = queryParameters.set('id.notEquals', <any>idNotEquals);
        }
        if (idSpecified !== undefined && idSpecified !== null) {
            queryParameters = queryParameters.set('id.specified', <any>idSpecified);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (roleCodeContains !== undefined && roleCodeContains !== null) {
            queryParameters = queryParameters.set('roleCode.contains', <any>roleCodeContains);
        }
        if (roleCodeDoesNotContain !== undefined && roleCodeDoesNotContain !== null) {
            queryParameters = queryParameters.set('roleCode.doesNotContain', <any>roleCodeDoesNotContain);
        }
        if (roleCodeEquals !== undefined && roleCodeEquals !== null) {
            queryParameters = queryParameters.set('roleCode.equals', <any>roleCodeEquals);
        }
        if (roleCodeIn) {
            roleCodeIn.forEach((element) => {
                queryParameters = queryParameters.append('roleCode.in', <any>element);
            })
        }
        if (roleCodeNotEquals !== undefined && roleCodeNotEquals !== null) {
            queryParameters = queryParameters.set('roleCode.notEquals', <any>roleCodeNotEquals);
        }
        if (roleCodeSpecified !== undefined && roleCodeSpecified !== null) {
            queryParameters = queryParameters.set('roleCode.specified', <any>roleCodeSpecified);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any>size);
        }
        if (sort) {
            sort.forEach((element) => {
                queryParameters = queryParameters.append('sort', <any>element);
            })
        }
        if (userIdEquals !== undefined && userIdEquals !== null) {
            queryParameters = queryParameters.set('userId.equals', <any>userIdEquals);
        }
        if (userIdGreaterThan !== undefined && userIdGreaterThan !== null) {
            queryParameters = queryParameters.set('userId.greaterThan', <any>userIdGreaterThan);
        }
        if (userIdGreaterThanOrEqual !== undefined && userIdGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('userId.greaterThanOrEqual', <any>userIdGreaterThanOrEqual);
        }
        if (userIdIn) {
            userIdIn.forEach((element) => {
                queryParameters = queryParameters.append('userId.in', <any>element);
            })
        }
        if (userIdLessThan !== undefined && userIdLessThan !== null) {
            queryParameters = queryParameters.set('userId.lessThan', <any>userIdLessThan);
        }
        if (userIdLessThanOrEqual !== undefined && userIdLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('userId.lessThanOrEqual', <any>userIdLessThanOrEqual);
        }
        if (userIdNotEquals !== undefined && userIdNotEquals !== null) {
            queryParameters = queryParameters.set('userId.notEquals', <any>userIdNotEquals);
        }
        if (userIdSpecified !== undefined && userIdSpecified !== null) {
            queryParameters = queryParameters.set('userId.specified', <any>userIdSpecified);
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<RoleAssignationDTO>>('get',`${this.basePath}/api/role-assignations`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getRoleAssignation
     * 
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRoleAssignationUsingGET(id: number, observe?: 'body', reportProgress?: boolean): Observable<RoleAssignationDTO>;
    public getRoleAssignationUsingGET(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RoleAssignationDTO>>;
    public getRoleAssignationUsingGET(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RoleAssignationDTO>>;
    public getRoleAssignationUsingGET(id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getRoleAssignationUsingGET.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<RoleAssignationDTO>('get',`${this.basePath}/api/role-assignations/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateRoleAssignation
     * 
     * @param body roleAssignationDTO
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateRoleAssignationUsingPUT(body: RoleAssignationDTO, observe?: 'body', reportProgress?: boolean): Observable<RoleAssignationDTO>;
    public updateRoleAssignationUsingPUT(body: RoleAssignationDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RoleAssignationDTO>>;
    public updateRoleAssignationUsingPUT(body: RoleAssignationDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RoleAssignationDTO>>;
    public updateRoleAssignationUsingPUT(body: RoleAssignationDTO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateRoleAssignationUsingPUT.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<RoleAssignationDTO>('put',`${this.basePath}/api/role-assignations`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
